/* eslint-disable consistent-return */
/* eslint-disable no-shadow */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-return-await */
/*
 *
 * framework test cases are tested in platform only so excluding here */
import log from 'loglevel';

import { fetchFromUrl, getConfigFromNodeId, getPropsFromNode, isNestedComponent, isValidProps } from './utils';

const checkRouteWithChildren = routeWithChildren => Array.isArray(routeWithChildren) && routeWithChildren.length > 0;
const getComponentProps = async (app, config, pageConfig) => {
  const { ...compConfig } = config.data;
  const props = {
    config: compConfig
  };

  if (isNestedComponent(config)) {
    const children = {};
    const routes = config.data.routes || {};

    for (const [route, childrenArray] of Object.entries(routes)) {
      const routeWithChildren = await Promise.all(
        childrenArray.map(async child => {
          const ComponentClass = app.registeredComponents[child.component];

          if (typeof ComponentClass === 'undefined') {
            log.warn('Framework: No registered component found in catalog for this node', child);
            return {};
          }

          const config = await getConfigFromNodeId(child.configId, pageConfig);

          const props = await getComponentProps(app, config, pageConfig);
          if (!isValidProps(props)) {
            log.warn('Framework: Can not extract props from config object', child);
            return {};
          }

          return {
            ComponentClass,
            props
          };
        })
      );
      if (checkRouteWithChildren(routeWithChildren)) {
        children[route] = routeWithChildren;
      }
    }
    props.children = children;
  }
  return props;
};

async function mountComponent(app, node, store, Provider, pageConfig) {
  try {
    // Get component id from node
    const componentId = node.dataset.componentid || null;

    // Get component class name from node and check if it exist in component registry
    const ComponentClass = app.getComponentClass(node);
    if (!ComponentClass) {
      log.error('Framework: No registered component found in catalog for this node', { ComponentClass, node });
      throw new Error('No registered component found');
    }

    // Check if render flag exist and set to false, otherwise consider it as a renderable component
    const isRender = !node.dataset.render || node.dataset.render !== 'false' || false;
    // If render flag is false, skip component rendering
    if (!isRender) {
      log.info(`Framework: Skipping component rendering, isRender is ${isRender}`, { ComponentClass, node });
      return false;
    }

    // Get component config from node
    const config = await getPropsFromNode(node, pageConfig);

    const props = await getComponentProps(app, config, pageConfig);
    if (!isValidProps(props)) {
      log.error('Framework: Can not extract props from config object');
      throw new Error('Invalid props');
    }

    // Render component using ReactDOM.render
    if (ComponentClass && isRender) {
      app.renderComponentWithData({
        componentId,
        ComponentClass,
        props,
        node,
        store,
        Provider
      });

      return true;
    }

    return false;
  } catch (error) {
    log.error('Framework: Component mount failed', error);
    return false;
  }
}

const getLocaleFromUrl = () => {
  // Get language & country from url
  const {
    urlSettings: { locale },
    server: { path }
  } = window.__APP_CONFIG__ || { urlSettings: { locale: {} }, server: { path: '' } };
  const pathComps = window.location.pathname.slice(path.length).split('/');
  let basename = '';
  let lang;
  let country;
  if (locale.country && locale.lang) {
    [, country, lang] = pathComps;
    basename = `/${country}/${lang}`;
  } else if (locale.lang) {
    [, lang] = pathComps;
    basename = `/${lang}`;
  } else if (locale.country) {
    [, country] = pathComps;
    basename = `/${country}`;
  }
  // Set basename to server path
  window.__APP_CONFIG__.server.path = `${path}${basename}${basename ? '/pages' : ''}`;
  window.__APP_CONFIG__.locale = {
    ...window.__APP_CONFIG__.locale,
    ...(lang && { lang }),
    ...(country && { country: country.toUpperCase() })
  };
  return { lang, country };
};

const localeObj = getLocaleFromUrl();

const logger = require('../logger');

const getPageConfig = async (opts = {}) => {
  let pageConfig = {};
  const { modelPath, strapi, configId, defaultLang = 'en' } = opts;
  const { lang: locale = defaultLang } = localeObj;
  if (!modelPath) return {};
  const url = strapi ? `${modelPath}/${configId}` : `${modelPath}/${locale}/${configId}`;
  try {
    pageConfig = await fetchFromUrl(url);
    if (strapi && locale !== pageConfig.locale) {
      const { localizations = [] } = pageConfig;
      const localizedConfig = localizations.find(entries => entries.locale === locale);
      if (localizedConfig) {
        pageConfig = await fetchFromUrl(`${modelPath}/${localizedConfig.id}`);
      }
    }
    return pageConfig;
  } catch (e) {
    if (!strapi) logger.error(`The next JSON model: ${modelPath}/${locale}/${configId} was not properly loaded`, e);
    return pageConfig;
  }
};

const init = async (app, nodeList, store = null, Provider = null) => {
  // Loop through each component and mount
  const pageConfig = await getPageConfig(app.options);
  await Promise.all([...nodeList].map(async node => await mountComponent(app, node, store, Provider, pageConfig.data)));
};

export default init;
